import { ApiGetActiveChatResponse } from './types/ApiGetActiveChatResponse'
import { ApiRecalculateRequest } from './types/ApiRecalculateRequest'
import { AxiosProvider } from '../AxiosProvider'
import { ApiChatMessagesResponse } from './types/ApiChatMessagesResponse'

export class ApiClientChats {
  private readonly path = '/api/v1/chats'

  constructor(private provider: AxiosProvider) {}

  async getChatMessages(
    {
      chatId,
      lastMessageId,
    }: {
      chatId: string
      lastMessageId?: string
    },
    _signal?: AbortSignal,
  ): Promise<ApiChatMessagesResponse> {
    return this.provider.request({
      url: [this.path, chatId, 'messages'].join('/'),
      method: 'get',
      params: {
        lastMessageId,
        pageSize: 200,
      },
    })
  }

  async getActiveChat(source?: string): Promise<ApiGetActiveChatResponse> {
    return this.provider.request({
      url: [this.path, 'active'].join('/'),
      method: 'post',
      params: { source },
    })
  }

  async assist(chatId: string): Promise<void> {
    return this.provider.request({
      url: [this.path, chatId, 'assist'].join('/'),
      method: 'put',
      params: {
        notifyAgent: true,
      },
    })
  }

  async cancelChat(chatId: string): Promise<void> {
    return this.provider.request({
      url: [this.path, chatId, 'cancel'].join('/'),
      method: 'put',
    })
  }

  async recalculate(chatId: string, data: ApiRecalculateRequest): Promise<void> {
    return this.provider.request({
      url: [this.path, chatId, 'recalculate'].join('/'),
      method: 'put',
      data,
    })
  }
}
